$ = window.jQuery;

export default obj => {
    // Retaining hover animation for `.cards__detail`
    obj.has(".cards__detail")
        .on("mouseover", function () {
            const $this = $(this),
                detail = $(".cards__detail", this).get(0),
                max = $this.height(),
                height = detail.scrollHeight;
            detail.style.maxHeight = Math.min(max, height) + "px";
        })
        .on("mouseout", function () {
            $(".cards__detail", this).get(0).style.maxHeight = 0;
        });

    // Ensure jQuery is targeting correct elements
    $(document).on("click", ".cards--subcategory .cards__toggle", function (e) {
        e.preventDefault();

        const $button = $(this);
        const $category = $button.closest(".cards__item");
        const $submenu = $category.next(".cards__subcategories-container");

        // Toggle subcategory visibility
        const isOpen = $submenu.is(":visible");

        $(".cards__subcategories-container").slideUp(300);
        $(".cards--subcategory .cards__toggle").attr("aria-expanded", "false").find(".arrow").removeClass("open");
        $(".cards__item").removeClass("active-category"); // Remove grayscale from all

        if (!isOpen) {
            $button.attr("aria-expanded", "true").find(".arrow").addClass("open");
            $submenu.slideDown(300);
            $category.addClass("active-category"); // Apply grayscale effect
        }
    });
};
